import { z } from 'zod';

export const createUserSchema = z.object({
  email: z.string().email('Invalid email address').optional().or(z.literal('')),
  username: z.string().min(3, 'Username must be at least 3 characters').max(30, 'Username must not exceed 30 characters'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  displayName: z.string().min(2, 'Display name must be at least 2 characters'),
  roles: z.array(z.string()).optional(),
  permissions: z.array(z.string()).optional(),
  avatarUrl: z.string().optional().nullable(),
  companyId: z.string().optional().nullable(),
  departmentId: z.string().optional().nullable(),
  position: z.string().optional().nullable(),
  employeeId: z.string().optional().nullable(),
});

export const updateUserSchema = z.object({
  email: z.string().email('Invalid email address').optional().or(z.literal('')),
  username: z.string().min(3, 'Username must be at least 3 characters').max(30).optional(),
  password: z.string().min(6, 'Password must be at least 6 characters').optional(),
  displayName: z.string().min(2, 'Display name must be at least 2 characters').optional(),
  avatarUrl: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  isActive: z.boolean().optional(),
  roles: z.array(z.string()).optional(),
  permissions: z.array(z.string()).optional(),
  companyId: z.string().optional().nullable(),
  departmentId: z.string().optional().nullable(),
  position: z.string().optional().nullable(),
  employeeId: z.string().optional().nullable(),
});

export const searchUserSchema = z.object({
  query: z.string().min(1, 'Search query cannot be empty'),
  limit: z.string().optional().transform(v => v ? parseInt(v) : 20),
});

export const assignVisibilitySchema = z.object({
  visibleUserIds: z.array(z.string()),
});
